module.exports = __webpack_public_path__ + "img/rank8.0ef7d90b.png";